import { Lead } from "@/modules/leads/types";
import { useState, useEffect, Ref } from "react";
import { Row } from "react-table";
import CheckboxIcon from "@/assets/icons/leads-table/checkbox-icon";
import { CheckboxProps, Checkbox, Box } from "@mui/material";

interface MuiCheckboxProps {
  ref: Ref<HTMLButtonElement>;
}
const BpIcon = () => {
  return (
    <Box
      sx={{
        borderRadius: "6px",
        width: 20,
        height: 20,
        boxShadow:
          "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
        backgroundColor: "#f5f8fa",
        backgroundImage:
          "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
        ".Mui-focusVisible &": {
          outline: "2px auto rgba(19,124,189,.6)",
          outlineOffset: 2,
        },
        "input:hover ~ &": {
          backgroundColor: "#ebf1f5",
        },
        "input:disabled ~ &": {
          boxShadow: "none",
          background: "rgba(206,217,224,.5)",
        },
      }}
    />
  );
};

const BpCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      disableFocusRipple
      disableTouchRipple
      color="default"
      checkedIcon={<CheckboxIcon />}
      icon={<BpIcon />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
};

export const MuiCheckbox = ({ ...rest }, { ref }: MuiCheckboxProps) => {
  return <BpCheckbox ref={ref} {...rest} />;
};

const TableRowCheckbox = ({ row }: { row?: Row<Lead> }) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked((row?.isSelected && row?.isSelected) || false);
  }, [row?.isSelected]);

  const handleClick = () => {
    row?.toggleRowSelected();
    setChecked(!checked);
  };

  return <MuiCheckbox checked={checked} onClick={handleClick} />;
};

export default TableRowCheckbox;
